export const environment = {
  firebase: {
    projectId: 'intercessioner',
    appId: '1:697208538114:web:4f07a0df61a98b9be3131b',
    storageBucket: 'intercessioner.appspot.com',
    apiKey: 'AIzaSyDDYJGkS0zMVP0xMpR-zZ3PGjyLdhZqOkw',
    authDomain: 'intercessioner.firebaseapp.com',
    messagingSenderId: '697208538114',
  },
  api: {
    ncessorUrl: 'https://us-central1-intercessioner.cloudfunctions.net/ncessor2gen',
  },
  useEmulators: false,
  production: true,
  dateOverride: undefined,
};
